<template>
  <div class="tabs-component">
    <div class="tabs-component__header">

      <select @change="selectTab($event.target.value)" name="tabs">
        <option v-for="tab in tabs" :key="tab.name" :selected="tab.isActive">{{ tab.name }}</option>
      </select>

      <svg-chevron-left class="select-arrow"></svg-chevron-left>

      <ul class="scrollable">
        <li v-for="tab in tabs" :class="{ 'is-active': tab.isActive }" @click="selectTab(tab.name)">
          {{ tab.name }}
        </li>
      </ul>
    </div>

    <div class="tabs-component__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',

  data() {
    return {
      tabs: []
    };
  },

  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.name == selectedTab);
      });
    }
  }
}
</script>
